import { KYMW0500Model } from '../kymw0500.model';
import { GetGoodsDataModel } from '../vo/get-goods-data.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 紐付商品コードを指定し、紐付商品単位に商品情報を取得する
 *
 * @export API通信成功時の処理
 * @class GetGoodsDataService
 * @extends {PlessResponder}
 */
@Injectable()
export class GetGoodsDataService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW0500Model;
  private vo: GetGoodsDataModel;
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ProcessDiv: this.vo.processDiv,
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        MainPCode: this.vo.mainPCode,
        PCode: this.vo.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW0500Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetGoodsDataService
   */
  execute(model: KYMW0500Model, vo: GetGoodsDataModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.send('getGoodsData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsDataService
   */
  success(data: any) {
    // 取得した商品データを反映する
    this.model.setGoodsData(data, this.vo.index);
    this.model.kymw0500Component.focusedRow = this.vo.index;
    // 排他処理を行う
    if (this.model.processDiv === '1') {
      this.model.kymw0500Component.lockOK_Row();
    } else {
      this.model.kymw0500Component.LockUtilForPlanGoods('REGIST',
        this.model.orderCode,
        this.model.mediumType,
        this.vo.pCode,
        () => this.model.kymw0500Component.lockOK_Row(this.vo.pCode),
        this.vo.pCode,
        (param: any, result: any): void => {
          this.model.kymw0500Component.lockErr_Row({ result });
        },
        null,
        false);
    }
  }
}

